<script setup>

</script>

<template>
  <footer>
    <v-container>
      <v-row class="section-padding text-md-right text-center footer-items">
        <v-col cols="12" lg="3" md="6" :class="[$vuetify.display.mdAndDown?'text-right':'']">
          <h1>درباره ما</h1>
          <ul class="mr-4">
            <li><router-link :to="{name:'about'}"> کلاسینو</router-link></li>
<!--            <li><router-link :to="{name:'contact'}">موقعیت های شغلی</router-link></li>-->
            <li><a href="https://mag.classino.com">بلاگ</a></li>
            <li><router-link :to="{name:'professors'}">اساتید کلاسینو</router-link></li>
            <li><router-link :to="{name:'contact'}">تماس با ما</router-link></li>
          </ul>
        </v-col>
        <v-col cols="12" lg="3" md="6" :class="[$vuetify.display.mdAndDown?'text-right':'']">
          <h1>پشتیبانی و راهنمایی</h1>
          <ul class="mr-4">
            <li>
              <span>پشتیبانی سایت:</span>
              <v-btn
                class="mr-4 rounded-lg secondary-success"
                border="success sm opacity-100"
                href="tel:02191008020"
                height="35px"
                variant="elevated"
                flat
                size="small"
                color="#ECFDF3"
                append-icon="$mdiPhoneInTalkOutline"
              >
                ۰۲۱‌-۹۱۰۰۸۰۲۰
              </v-btn>
            </li>
            <li><router-link :to="{name:'faq'}" >سوالات متداول</router-link></li>
            <li><router-link :to="{name:'required-softwares'}" >نرم افزارهای مورد نیاز</router-link></li>
            <li><router-link :to="{name:'policy'}">قوانین و شرایط استفاده</router-link></li>
          </ul>
        </v-col>
        <v-col cols="12" lg="3" md="6" :class="[$vuetify.display.mdAndDown?'text-right':'']">
          <h1>دوره‌های کلاسینو</h1>
          <ul class="mr-4">
            <li><a href="/courses?courses=&grades=2&lessons=&professors=&fields=">کنکور</a></li>
            <li><a href="/courses?courses=421&grades=&lessons=&professors=&fields=">تیزهوشان ششم</a></li>
            <li><a href="/courses?courses=418&grades=&lessons=&professors=&fields=">تیزهوشان نهم</a></li>
<!--            <li><router-link :to="{name:'professors'}">پیشرفت تحصیلی</router-link></li>-->
          </ul>
        </v-col>
        <v-col cols="12" lg="3" md="6" :class="[$vuetify.display.mdAndDown?'text-right':'']" class="permissions">
          <div class="permissions-title">
            <h1>مجوزها</h1>
          </div>
          <div class="d-flex" :class="[$vuetify.display.mdAndDown?'flex-row':'flex-column']">
            <div class="permission-logos ml-5">
              <a target="_blank" href="https://trustseal.enamad.ir/?id=94650&Code=pxwcSzLKuCDnTpM2r8oj" aria-label="e-namad" >
                <img src="../assets/images/logo/enamad.png" alt="enamad"
                     style="cursor:pointer; width: 90px; height: 98px" id="pxwcSzLKuCDnTpM2r8oj">
              </a>
              <!--            <div id="iwmf-certificate"></div>-->
              <img id='jxlzesgtesgtapfusizpesgtwlao' style='cursor:pointer'
                   onclick='window.open("https://logo.samandehi.ir/Verify.aspx?id=1005904&p=rfthobpdobpddshwpfvlobpdaods", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")'
                   alt='logo-samandehi'
                   src='https://logo.samandehi.ir/logo.aspx?id=1005904&p=nbpdlymalymaujynbsiylymashwl'/>
            </div>
            <div class="social-link mt-6">
              <a href="http://instagram.com/classino__com"  target="_blank">
                <img alt="classino instagram" src="../assets/images/social/instagram.gif" >
              </a>
              <a href="http://telegram.me/classino_com" class="mx-6" target="_blank">
                <img alt="classino telegram" src="../assets/images/social/telegram.gif">
              </a>
              <a href="http://aparat.com/classino_com"  target="_blank">
                <img alt="classino aparat" src="../assets/images/social/aparat.gif">
              </a>
            </div>

          </div>
        </v-col>

      </v-row>
      <v-row class="footer-address mb-3 mb-md-0">
        <v-col cols="12" class="d-flex flex-wrap justify-content-center">
          <span>تمامی حقوق مادی و معنوی محفوظ میباشد.</span>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<style scoped lang="scss">
.secondary-success{
  color:#067647 !important; ;
}
.social-link{
  justify-content: flex-start;
}
.permission-logos{
  justify-content: flex-start !important;
  width: unset !important;
}
</style>
